import { render } from "./ApprovalConfirmationModal.vue?vue&type=template&id=bdb218a8&scoped=true"
import script from "./ApprovalConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ApprovalConfirmationModal.vue?vue&type=script&lang=js"

import "./ApprovalConfirmationModal.vue?vue&type=style&index=0&id=bdb218a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb218a8"]])

export default __exports__